import http from "./httpService";

const apiEndpoint = "/client/comment";

function commentUrl(id) {
  return `${apiEndpoint}/${id}`;
}

// function commentUrl(id) {
//   return `${apiEndpoint}/${id}`;
// }

export function getComments(documentid) {
  return http.get(commentUrl(documentid));
}

export function saveComment(comment) {
  return http.post(apiEndpoint, comment);
}
